// extracted by mini-css-extract-plugin
export default {"theme":"ThemeSwitch_theme__O4qrX"};